<div class="relative" *transloco="let t">
	<button class="absolute right-2 top-2 z-10" mat-icon-button mat-dialog-close [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>
	<h2 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">{{ t('realestates.choose') }}</h2>
	<mat-dialog-content>
		<ara-realestate-legacy [dialogMode]="true" (rowClicked)="onRealEstateSelected($event)"></ara-realestate-legacy>
	</mat-dialog-content>
</div>
